import Operations from "./Operations";

const Tickets = () => <Operations resource="tickets" />;

export default Tickets;
